export default __webpack_public_path__ + "static/media/ico-graph-u.fe00b7af.svg";